export const isModalAddTeamMemberSelector = (state: any) =>
  state.PartnerTeamReducer.isModalAddTeamMember;

export const teamMemberListSelector = (state: any) =>
  state.PartnerTeamReducer.teamMemberList;

export const teamMemberFilterSelector = (state: any) =>
  state.PartnerTeamReducer.teamMemberFilter;
